import Station, { UniversalStation } from './Station';
import Collection from './Collection';
import { isEmpty } from 'util/index';
import { TILE_SIZES } from 'globalConst/const';
import { UniversalCollection, UniversalConfig } from '../interfaces';
import CONTENT_TYPE_ID from 'globalConst/contentTypes-const';

const prioritizeFns = (s1: Station, s2: Station) => {
  if (s1.hasPage < s2.hasPage) {
    return -1;
  }
  if (s1.hasPage === s2.hasPage) {
    return 0;
  }
  return 1;
};

export interface UniversalStationCollection extends UniversalCollection {
  items: Array<UniversalStation>;
}

export default class StationCollection extends Collection {
  items: Array<Station>;
  tileSizes: string;

  constructor(collection: UniversalCollection, config?: UniversalConfig[], options?: string[]) {
    super(collection, config, options);
    if (isEmpty(collection)) {
      return null;
    }
    const stationCollection = <UniversalStationCollection>collection;

    this.tileSizes = TILE_SIZES.SMALL;
    this.items =
      stationCollection.items && stationCollection.items.map((station) => new Station(station)).sort(prioritizeFns);
    if (this.contentTypeId === CONTENT_TYPE_ID.FAVORITE_STATION_COLLECTION) {
      this.showEmptyState = true;
      this.hasEmptyStateComponent = true;
    }

    // Make this class read-only
    Object.freeze(this);
  }
}
